<template>
  <div class="letters">
    <LetterPreview
      v-for="(item, i) in previewItems"
      :key="`letter_${i}`"
      :letter="item?.letter"
      :context="item?.context"
      :include-screenshot="includeScreenshot"
      class="letter"
    />
  </div>
</template>

<script>
import Correspondence from "@/models/Correspondence";
import LetterPreview from "@/components/letters/LetterPreview.vue";
import {buildLetterContextForCorrespondence, LetterContext} from "@/models/letterContext";

export default {
  components: {LetterPreview},
  props: {
    items: {
      type: Array,
      default: () => [],
      validator: (arr) => {
        return Array.isArray(arr) && arr.every((x) => {
          return x.letter instanceof Correspondence
            && x.context instanceof LetterContext;
        });
      }
    },
    includeScreenshot: Boolean
  },
  computed: {
    previewItems() {
      return this.items
        .filter(item => item?.letter instanceof Correspondence)
        .map(item => {
          const context = item.context || buildLetterContextForCorrespondence(item.letter);
          return context?.city && context?.property ? {
            letter: item.letter,
            context
          } : null;
        })
        .filter(Boolean);
    }
  }
}
</script>

<style scoped>
.letters {
  display: flex;
  flex-direction: column;
  gap: 16px; /* space between child divs */
}
.letter {
  padding: 16px;
  border: 1px solid rgba(0,0,0,.12);
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0,0,0,.12);
  background: #fff;
}

/* Print overrides */
@media print {
  /* Optional: make sure the print layout isn't constrained like a modal */
  .modal, .modal-dialog, .modal-content {
    max-height: none !important;
    height: auto !important;
    overflow: visible !important;
  }

  /* Turn off flex gap quirks in print and use margin instead */
  .letters {
    display: block !important;
  }

  .letter {
    /* Remove “card” chrome */
    padding: 0 !important;           /* or keep some, your call */
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    background: transparent !important;

    /* Spacing between printed sections (optional) */
    margin: 0 0 24px 0 !important;

    /* Pagination rules */
    break-inside: avoid;
    page-break-inside: avoid;
    break-after: page;
    page-break-after: always;
  }

  /* Don't force a blank trailing page */
  .letter:last-child {
    break-after: auto;
    page-break-after: auto;
    margin-bottom: 0 !important;
  }
}
</style>
